import { version } from 'antd';
import semver from 'semver';

export interface WarnWhenReachAntdVersionMetadata {
	// Minimum version of antd that this message should be logged
	minAntdVersion: string;
	message: string;
	componentName: string;
	urlReference?: string;
}

const alreadyWarned = new Set<string>();

function getIdFromWarningObj(warningObj: WarnWhenReachAntdVersionMetadata) {
	return Object.keys(warningObj)
		.sort()
		.map(key => warningObj[key])
		.join('-');
}

/**
 * Use this when wanting to deprecate a component or a feature or event a hack that is added in newer versions of antd
 */
export function warnWhenReachedAntdVersion(props: WarnWhenReachAntdVersionMetadata) {
	if (process.env.NODE_ENV === 'production' || semver.lt(version, props.minAntdVersion)) {
		return;
	}

	// Needed for avoid getting the same warning multiple times
	const warningId = getIdFromWarningObj(props);

	if (alreadyWarned.has(warningId)) {
		return;
	}
	alreadyWarned.add(warningId);

	let message = `${props.componentName} says: ${props.message}.\nthis is logged as we now reached antd version ${props.minAntdVersion} (current version ${version})\n`;
	if (props.urlReference) {
		message += `See ${props.urlReference} for more details.`;
	}

	// Add stack so we can see where the warning was called
	console.warn(message, new Error().stack);
}
